import { Navigate, useLocation } from 'react-router-dom';
import { PUBLIC_ROUTES } from '../constants/routes';

/** /landing_page moved to /; keep old links (and their #section) working. */
const LandingPageRedirect = () => {
  const { hash } = useLocation();
  return <Navigate to={{ pathname: PUBLIC_ROUTES.HOME, hash }} replace />;
};

export default LandingPageRedirect;
